export default __webpack_public_path__ + "static/media/cta1.b6cbd11f.png";